import { RoleFilterKey } from '@/Enums/UserManagement/RoleFilterKey.enum';
import { Role } from '@/Enums/Users/Role.enum';
import { IControlOption } from '@/Interfaces/ControlOption.interface';

export const USER_ROLE_LABELS: Record<Role, string> = {
  [Role.ADMIN]: 'Admin',
  [Role.ORG_ADMIN]: 'Organization Admin',
  [Role.WHITELABEL_ADMIN]: 'Whitelabel Admin',
  [Role.CLIENT]: 'Client',
  [Role.ADVERTISER]: 'Advertiser',
  [Role.AGENCY]: 'Agency',
};

export const USER_FILTER_LABELS = [
  { name: RoleFilterKey.ALL, label: 'All' },
  { name: RoleFilterKey.ADMIN, role: Role.ADMIN, label: 'Admin' },
  { name: RoleFilterKey.CLIENT, role: Role.CLIENT, label: 'Client' },
  { name: RoleFilterKey.AGENCY, role: Role.AGENCY, label: 'Agency' },
  { name: RoleFilterKey.ADVERTISER, role: Role.ADVERTISER, label: 'Advertiser' },
];

export const USER_FILTER_TO_USER_ROLE = {
  [RoleFilterKey.ADMIN]: [Role.ADMIN, Role.ORG_ADMIN, Role.WHITELABEL_ADMIN],
  [RoleFilterKey.CLIENT]: [Role.CLIENT],
  [RoleFilterKey.ADVERTISER]: [Role.ADVERTISER],
  [RoleFilterKey.AGENCY]: [Role.AGENCY],
};

export const ADMIN_USER_ROLE_OPTIONS: IControlOption[] = [
  Role.ADMIN,
  Role.ORG_ADMIN,
  Role.WHITELABEL_ADMIN,
  Role.CLIENT,
  Role.AGENCY,
  Role.ADVERTISER,
].map(role => ({ value: role, label: USER_ROLE_LABELS[role] }));

export const ORG_ADMIN_ADMIN_USER_ROLE_OPTIONS: IControlOption[] = ADMIN_USER_ROLE_OPTIONS.slice(1);
export const WHITELABEL_ADMIN_USER_ROLE_OPTIONS: IControlOption[] = ORG_ADMIN_ADMIN_USER_ROLE_OPTIONS.slice(1);

export const ALL_CHECKED = {
  [RoleFilterKey.ALL]: true,
  [RoleFilterKey.ADMIN]: false,
  [RoleFilterKey.CLIENT]: false,
  [RoleFilterKey.ADVERTISER]: false,
  [RoleFilterKey.AGENCY]: false,
};

export const ALL_UNCHECKED = Object.fromEntries(Object.values(RoleFilterKey).map(v => [v, false]));

export const BASE_TAB_ID = 'user-management-filter-tab';
